export const revealPersons = (data: any) => data?.map((d: any) => d.person) || [];
